module.exports = __webpack_public_path__ + "static/job-banner3-53e476e8c4c66a82d9ec536ed9992129.png";